<template>
    <div class="a-checkbox" :class="`${customClass}`">
        <input
            :id="id"
            class="a-control"
            type="checkbox"
            v-model="localChecked"
        />
        <label :for="id"><slot></slot> </label>
    </div>
</template>

<script>
export default {
    name: 'Checkbox',
    props: {
        customClass: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: 'checkbox'
        }
    },
    watch: {
        localChecked(value) {
            this.$emit('update:checked', value)
        }
    },
    data() {
        return {
            localChecked: false
        }
    }
}
</script>
